import { useLanguage } from '@/hooks/useLanguage';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

type Props = {
  showModal: boolean;
  handleRedirect: () => void;
  handleRefresh: () => void;
};

export const IdleTimeOutModal = (props: Props) => {
  const language = useLanguage();

  return (
    <Modal centered show={props.showModal} onHide={props.handleRefresh}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h5>
            {language == 'en' ? 'Page Expired' : 'Halaman Tamat Tempoh'}
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {language == 'en'
          ? 'Page expired due to inactivity on page.'
          : 'Halaman tamat tempoh kerana tidak aktif pada halaman.'}
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button size="sm" variant="warning" onClick={props.handleRefresh}>
          {language == 'en' ? 'Refresh Page' : 'Muat semula Halaman'}
        </Button>
        <Button
          size="sm"
          variant="outline-warning"
          onClick={props.handleRedirect}
        >
          {language == 'en'
            ? 'Leave This Page'
            : 'Meninggalkan halaman ini'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
